import React from "react";

export const CaptionContext = React.createContext({});
